// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
   .icon {
color: #3762f0;
font-size: 100pt;
  }

  .menu-btn{
    margin: 20px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0  51%, #368cdc  100%);
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    border-radius: 10px;
    color: white;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border:none;
    width:100%;
    font-weight: 500;
    font-size: 10pt;
    color: #ffffff;
    padding-right: 15%;
    text-align: right;
  }
  .gradient-section {
    background-image: linear-gradient(to right, #36D1DC 0%, #142ad0  51%, #36D1DC  100%);
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    border-radius: 10px;
    color: white;
    font-weight: 600;
    font-size: 16pt;
    padding: 30px;
    width: 200px;
    margin: 10px;



  }

  

  .sidebarContainer {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
  }
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.css"],"names":[],"mappings":";GACG;AACH,cAAc;AACd,gBAAgB;EACd;;EAEA;IACE,YAAY;IACZ,oFAAoF;IACpF,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,oFAAoF;IACpF,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,YAAY;;;;EAId;;;;EAIA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;EACd","sourcesContent":["\r\n   .icon {\r\ncolor: #3762f0;\r\nfont-size: 100pt;\r\n  }\r\n\r\n  .menu-btn{\r\n    margin: 20px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0  51%, #368cdc  100%);\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    border-radius: 10px;\r\n    color: white;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    border:none;\r\n    width:100%;\r\n    font-weight: 500;\r\n    font-size: 10pt;\r\n    color: #ffffff;\r\n    padding-right: 15%;\r\n    text-align: right;\r\n  }\r\n  .gradient-section {\r\n    background-image: linear-gradient(to right, #36D1DC 0%, #142ad0  51%, #36D1DC  100%);\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    border-radius: 10px;\r\n    color: white;\r\n    font-weight: 600;\r\n    font-size: 16pt;\r\n    padding: 30px;\r\n    width: 200px;\r\n    margin: 10px;\r\n\r\n\r\n\r\n  }\r\n\r\n  \r\n\r\n  .sidebarContainer {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    height: 100%;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
